module.exports = __webpack_public_path__ + "img/line_blue.10fdc829.svg";